export const VERSION = '5.7.0'; // x-release-please-version
//# sourceMappingURL=version.mjs.map